export default __webpack_public_path__ + "static/media/hook.fe99b70f.glb";